// extracted by mini-css-extract-plugin
export default {"closeContainer":"qJSB63e2","absCloseBtn":"vOFcsaQO"};